import { useEffect } from 'react';

import { useTranslationsContext } from '@state/checkout-contexts';
import { ChkStatusScreen } from '@ui/checkout-components';

import { ViewContainer } from '../../components/ViewContainer/ViewContainer';
import { useErrorContext } from '../../contexts/error/errorContext';
import { SCA_EVENTS } from '../../models/globals/events.constants';
import { TEST_IDS } from '../../models/globals/testIds.constants';
import { useScaSubject } from '../../providers/ScaSubjectProvider/ScaSubjectProvider.hooks';
import { dataLayer } from '../../utils/dataLayer';
import { TRANSLATION_KEYS } from '../../utils/TranslationKeys';

export const DecoupledVerificationView = () => {
  const { setError, errorCode } = useErrorContext();
  const { t } = useTranslationsContext();
  const { error } = useScaSubject();

  useEffect(() => {
    dataLayer.trackEvent({
      name: SCA_EVENTS.DECOUPLED_VERIFICATION_PAGE_DISPLAYED,
    });
  }, []);

  useEffect(() => {
    if (error) {
      setError(error);
      dataLayer.trackEvent({
        name: SCA_EVENTS.DECOUPLED_VERIFICATION_PAGE_ERROR,
        properties: {
          code: errorCode,
        },
      });
    }
  }, [error, setError, errorCode]);

  return (
    <ViewContainer>
      <ChkStatusScreen
        title={t(TRANSLATION_KEYS.APPROVE_YOUR_PAYMENT_IN_APP)}
        text={t(TRANSLATION_KEYS.TAP_THE_PUSH_NOTIFICATION_FROM)}
        animation="pendingMobile"
        sx={{ height: '100%' }}
        data-testid={TEST_IDS.SCA_DECOUPLED_VERIFICATION_VIEW_ANIMATION}
      />
    </ViewContainer>
  );
};
